// 外部から投稿されたデータを表示する(地図側)。

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { MapContainer, TileLayer, Marker, ZoomControl, Circle } from 'react-leaflet';
import { icon } from 'leaflet';

/*-------------------
    cssのimport
---------------------*/
import '../css/public.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
/*-------------------
    画像のimport
---------------------*/
import iconMarker from 'leaflet/dist/images/marker-icon.png';
import imgLoading from '../images/icon/loading_b.png';

/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import * as commonHtml from '../commonHtml';
import * as crtMrkr from './createMarker';
import MyComponent from '../components/UseMapEvents';

// 現在位置のマーカーを作成する。
const markerIcon = icon({
  iconUrl: iconMarker,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
});

// クラス名
class PublicMap extends Component {
  constructor(props) {
    super(props);

    // URLを取得。
    const url = props.location.pathname;
    // 乱数を取得する。
    const num = url.lastIndexOf('/');
    const lgCrypt = url.slice(num + 1);

    this.state = {
      agreeFlag: '0',
      lgCrypt,
      imgModal: [],
      dispDistance: 0,
      // 地図用
      iconUrl: '',
      mapFlag: '0',
      mapPositon: [],
      mapZoom: '',
      mapKey: commons.randomNum(),
      tileAttribution: '',
      tileUrl: '',
      ocStat: true,
      isGuideOpen: false,
      guideList: [],
      hiddenList: [], // 凡例での表示切替用
      // マーカー系統
      postMarker: [],
      roadMarker: [],
      havenMarker: [],
      radioMarker: [],
      stdMarker: [],
      areaMarker: [],
      // メニューのチェック欄
      fcmlyFlag: 0,
      hzrdFlag: 0,
      // その他
      linkContent: null,
      currentMarker: null,
    };
  }

  componentDidMount = async () => {
    const { lgCrypt } = this.state;
    const { lgCd, permission: prmsn } = await commons.getLgCd(lgCrypt);
    if (lgCd === '') {
      commons.moveErrorPage(this.props, '10');
      return;
    }
    // 設定系統を取得する。
    const promise = [];

    // 日本語マスタを取得
    promise.push(commons.commonSetting({ colName: 'M_JP', objName: 'jpMasta' }));

    // 地図設定を取得
    promise.push(commons.commonSetting({ colName: 'M_URL_SETTING', objName: 'mapSetting' }));

    // 市町村設定を取得
    promise.push(commons.commonSetting({ lgCd, colName: 'M_LCL_SETTING', objName: 'lclSetting' }));

    // リンク設定マスタを取得
    promise.push(
      commons.commonSetting({ lgCd, enable: true, colName: 'M_LINK_SETTING', objName: 'linkData' })
    );

    // 全てのプロミスが完了した後に行う処理。
    const results = await Promise.all(promise);
    const resultList = commons.changePromiseRes(results);

    const { jpMasta, mapSetting, lclSetting, linkData = [] } = resultList;
    const resSetting = this.getSetting(mapSetting, lclSetting, prmsn);
    const markerSetting = await this.createMarker(resSetting, jpMasta, lgCd, prmsn);
    const linkContent = commonHtml.linkList(linkData);

    this.setState({ ...resSetting, ...markerSetting, linkContent, jpMasta, prmsn, lgCd });
  };

  /**
   * 設定情報を取得する。
   *
   * @memberof PublicMap
   */
  getSetting = (mapSetting, lclSetting, prmsn) => {
    // 地方公共団体の情報を取得
    if (lclSetting.length === 0 || mapSetting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return '';
    }

    // 地図の設定を取得
    const { map_url: mapUrl = '', other = '' } = mapSetting[0];
    const { google_map_path: googleMapPath = '' } = other;
    const {
      tile_url: tileUrl = '',
      tile_elev: tileElevUrl = '',
      tile_hillshade: tileHillshade = '',
      tile_fly: tileFlyUrl = '',
      tile_attribution: tileAttribution = '',
      flood_shinsui: floodShinsui = '',
      flood_shinsui_keikaku: shinsuiKeikaku = '',
      flood_shinsui_keizoku: shinsuiKeizoku = '',
      kaoku_hanran: kaokuHanran = '',
      kaoku_kagan: kaokuKagan = '',
      land_kyukeisya: landKyukeisya = '',
      land_dosekiryu: landDosekiryu = '',
      land_jisuberi: landJisuberi = '',
      tsunami_shinsui: tsunamiShinsui = '',
    } = mapUrl;

    const hazardList = [
      <TileLayer url={floodShinsui} opacity={0.7} maxNativeZoom={17} />,
      <TileLayer url={shinsuiKeikaku} opacity={0.7} maxNativeZoom={17} />,
      <TileLayer url={shinsuiKeizoku} opacity={0.7} maxNativeZoom={17} />,
      <TileLayer url={kaokuHanran} opacity={0.7} maxNativeZoom={17} />,
      <TileLayer url={kaokuKagan} opacity={0.7} maxNativeZoom={17} />,
      <TileLayer url={landDosekiryu} opacity={0.7} maxNativeZoom={17} />, // 5
      <TileLayer url={landKyukeisya} opacity={0.7} maxNativeZoom={17} />,
      <TileLayer url={landJisuberi} opacity={0.7} maxNativeZoom={17} />,
      <TileLayer url={tsunamiShinsui} opacity={0.7} maxNativeZoom={17} />,
    ];

    const {
      center_point: latLng = [],
      center_zoom: centerZoom = 15,
      public_map: publicMap = '',
    } = lclSetting[0] || '';
    const { title = '', icon_url: iconUrl = '', staff = '', citizen = '', agree = '' } = publicMap;
    const useSetting = prmsn === 7 ? staff : citizen;
    const { facility = 0, hazard = 0, agree_disp: agreeDisp = false } = useSetting;

    if (title === '') {
      commons.moveErrorPage(this.props, '30');
      return '';
    }

    document.title = title; // タブのタイトルを設定する。

    // faviconの変更
    if (iconUrl !== '') {
      const link = document.querySelector("link[rel~='icon']");
      link.href = iconUrl;
    }

    // URLから中心座標を取得する。
    const { location } = this.props;
    const urlQuery = new URLSearchParams(location.search);
    const urlLat = urlQuery.get('lat') || '';
    const urlLng = urlQuery.get('lng') || '';
    const urlZoom = urlQuery.get('zoom') || '';
    const chMp = urlQuery.get('map') || '0';
    const chGuide = urlQuery.get('guide') || '0';

    const mapZoom = urlZoom === '' ? centerZoom : urlZoom;
    const agreeFlag = sessionStorage.getItem('agree') || '0';

    return {
      googleMapPath,
      mapPositon: urlLat === '' ? latLng : [urlLat, urlLng],
      currentPoint: [latLng[1], latLng[0]],
      currentMarker: <Marker position={latLng} icon={markerIcon} />,
      mapZoom,
      latlng: urlLat === '' ? latLng : [urlLat, urlLng],
      nowZoom: urlZoom === '' ? centerZoom : urlZoom,
      isGuideOpen: chGuide === '1',
      formTitle: title,
      iconUrl,
      tileAttribution,
      tileUrl,
      tileElevUrl,
      tileHillshade,
      tileFlyUrl,
      mapFlag: chMp,
      facility,
      hazard,
      hazardList,
      urlSearch: location.search,
      agree,
      agreeFlag: agreeDisp === false ? true : agreeFlag === '1',
    };
  };

  /**
   * 地図に表示するメーカーを作成する。
   * @memberof BaseMap
   */
  createMarker = async (resSetting, jpMasta, lgCd, prmsn) => {
    const { guideList } = this.state;
    const { facility, hazard, currentPoint } = resSetting;

    const { location } = this.props;
    const urlQuery = new URLSearchParams(location.search);
    const chHzrd = urlQuery.get('hzrd') || '0';
    const chFcmly = urlQuery.get('fcmly') || '';
    const resData = await this.getData(resSetting, jpMasta, lgCd, prmsn, currentPoint);

    const {
      havenData = [],
      postData = [],
      roadData = [],
      radioData = [],
      stdData = [],
      areaData = [],
    } = resData;

    // 全部が空だった場合は欄を表示しないようにする。
    const resDistanceData = havenData.length + postData.length + stdData.length;
    const resSumData = resDistanceData + roadData.length + areaData.length + radioData.length;

    // 初期の凡例を判定する。
    if (chHzrd !== '') {
      const checkHzrd = parseInt(chHzrd, 10);
      if (hazard & 1 && checkHzrd & 1) guideList.push('hzrdFlag_1');
      if (hazard & 2 && checkHzrd & 2) guideList.push('hzrdFlag_2');
      if (hazard & 4 && checkHzrd & 4) guideList.push('hzrdFlag_4');
      if (hazard & 8 && checkHzrd & 8) guideList.push('hzrdFlag_8');
      if (hazard & 16 && checkHzrd & 16) guideList.push('hzrdFlag_16');
      if (hazard & 32 && checkHzrd & 32) guideList.push('hzrdFlag_32');
      if (hazard & 64 && checkHzrd & 64) guideList.push('hzrdFlag_64');
      if (hazard & 128 && checkHzrd & 128) guideList.push('hzrdFlag_128');
      if (hazard & 256 && checkHzrd & 256) guideList.push('hzrdFlag_256');
    }

    // URLに設定がない場合
    let tmpFcmly = 0;
    if (havenData.length > 0) tmpFcmly += 1;
    if (postData.length > 0) tmpFcmly += 2;
    if (roadData.length > 0) tmpFcmly += 4;
    if (radioData.length > 0) tmpFcmly += 8;
    if (stdData.length > 0) tmpFcmly += 16;
    if (areaData.length > 0) tmpFcmly += 32;

    const useFcmly = chFcmly === '' ? tmpFcmly : parseInt(chFcmly, 10);
    if (facility & 1 && useFcmly & 1) guideList.push('fcmlyFlag_1');
    if (facility & 2 && useFcmly & 2) guideList.push('fcmlyFlag_2');
    if (facility & 4 && useFcmly & 4) guideList.push('fcmlyFlag_4');
    if (facility & 8 && useFcmly & 8) guideList.push('fcmlyFlag_8');
    if (facility & 16 && useFcmly & 16) guideList.push('fcmlyFlag_16');
    if (facility & 32 && useFcmly & 32) guideList.push('fcmlyFlag_32');

    // チェックの入っているメニューは初期から開く。
    if (parseInt(chHzrd, 10) > 0) this.openMenu('accordionMenu10');
    if (useFcmly > 0) this.openMenu('accordionMenu20');

    return {
      ...resData,
      hzrdFlag: parseInt(chHzrd, 10),
      fcmlyFlag: useFcmly,
      dispFcmlyFlag: tmpFcmly,
      guideList,
      resSumData,
      resDistanceData,
    };
  };

  /**
   * マーカーデータを取得する。
   * @memberof PublicMap
   */
  getData = async (resSetting, jpMasta, lgCd, prmsn, currentPoint) => {
    const { dispDistance: distance, hiddenList } = this.state;
    const { facility, googleMapPath } = resSetting;
    const { haven, roadclose, standard } = jpMasta[0] || '';
    const { kind_list: roadKind = [] } = roadclose;

    // 設定系統を取得する。
    const promise = [];

    // FIXME:範囲検索するマーカーはDBにindexを貼る必要あり
    const comObj = { lgCd, pubFlag: true, distance, currentPoint };

    // 避難所を取得
    if (facility & 1) {
      promise.push(commons.getMarker({ ...comObj, colName: 'M_HAVEN', objName: 'havenData' }));
    }

    // 投稿データを取得
    if (facility & 2) {
      promise.push(
        commons.getMarker({ ...comObj, colName: 'T_POST_RESIDENT', objName: 'postData' })
      );
    }

    // 通行止め情報を取得
    if (facility & 4) {
      promise.push(
        commons.getMarker({ lgCd, pubFlag: true, colName: 'T_ROAD_CLOSE', objName: 'roadData' })
      );
    }

    // 屋外子局を取得
    if (facility & 8) {
      promise.push(commons.getMarker({ lgCd, colName: 'M_DP_RADIO', objName: 'radioData' }));
    }

    // 位置情報を取得
    if (facility & 16) {
      promise.push(
        commons.getMarker({ ...comObj, colName: 'M_STANDARD_MARKER', objName: 'stdData' })
      );
    }

    // エリア情報を取得
    if (facility & 32) {
      promise.push(
        commons.getMarker({ lgCd, pubFlag: true, colName: 'M_AREA_MARKER', objName: 'areaData' })
      );
    }

    // 全てのプロミスが完了した後に行う処理。
    const results = await Promise.all(promise);
    const resultList = commons.changePromiseRes(results);
    const {
      havenData = [],
      postData = [],
      roadData = [],
      radioData = [],
      stdData = [],
      areaData = [],
    } = resultList;

    // 引数の共通要素
    const commonProp = {
      onClickGuide: this.changeGuide,
      googleMapPath,
      onClickImg: this.onClickImg,
      prmsn,
    };

    // 各マーカーを作成する。
    const resHaven = crtMrkr.havenMarker(havenData, haven, hiddenList, commonProp);
    const resPost = crtMrkr.postMarker(postData, hiddenList, commonProp);
    const resRoad = crtMrkr.roadMarker(roadData, roadKind, hiddenList, commonProp);
    const radioMarker = crtMrkr.radioMarker(radioData, commonProp);
    const resStd = crtMrkr.stdMarker(stdData, standard, hiddenList, commonProp);
    const resArea = crtMrkr.areaMarker(areaData, hiddenList, commonProp);

    return {
      ...resultList,
      ...resHaven,
      ...resPost,
      ...resRoad,
      radioMarker,
      ...resStd,
      ...resArea,
    };
  };

  /**
   * 地図のメニュー欄を開くか
   * @memberof PublicMap
   */
  openMenu = (elemName) => {
    const elem = document.getElementById(elemName) || { checked: false };
    elem.checked = true;
  };

  // 同意画面で同意を押した際の初期処理
  agreeInit = (stateValue) => {
    // setStateが完了し、renderが走った後にメニューを開く必要がある。
    this.setState({ ...stateValue }, () => {
      const { hzrdFlag, fcmlyFlag } = this.state;
      // チェックの入っているメニューは初期から開く。
      if (hzrdFlag > 0) this.openMenu('accordionMenu10');
      if (fcmlyFlag > 0) this.openMenu('accordionMenu20');
    });
  };

  /**
   * 凡例を押した際の処理
   * @memberof PublicMap
   */
  changeGuide = (addKind, addValue) => {
    const {
      hiddenList,
      jpMasta,
      havenData,
      postData,
      roadData,
      stdData,
      areaData,
      googleMapPath,
      prmsn,
    } = this.state;

    const tmp = `${addKind}_S_${addValue}`;
    const num = hiddenList.indexOf(tmp);

    // リストにない場合は追加し、ある場合は削除
    if (num === -1) hiddenList.push(tmp);
    else hiddenList.splice(num, 1);

    // 選択したものに応じてマーカーと凡例を作り直す
    const { haven, roadclose, standard } = jpMasta[0] || '';
    const { kind_list: roadKind = [] } = roadclose;

    // 引数の共通要素
    const commonProp = {
      onClickGuide: this.changeGuide,
      googleMapPath,
      onClickImg: this.onClickImg,
      prmsn,
    };

    let tmpData = '';
    if (addKind === 'haven') {
      tmpData = crtMrkr.havenMarker(havenData, haven, hiddenList, commonProp);
    } else if (addKind === 'post') {
      tmpData = crtMrkr.postMarker(postData, hiddenList, commonProp);
    } else if (addKind === 'road') {
      tmpData = crtMrkr.roadMarker(roadData, roadKind, hiddenList, commonProp);
    } else if (addKind === 'std') {
      tmpData = crtMrkr.stdMarker(stdData, standard, hiddenList, commonProp);
    } else if (addKind === 'area') {
      tmpData = crtMrkr.areaMarker(areaData, hiddenList, commonProp);
    }

    this.setState({ ...tmpData, hiddenList });
  };

  /**
   * ポップアップの画像を押した際の処理
   * @memberof PublicMap
   */
  onClickImg = (setModal) => {
    this.setState({ imgModal: setModal });
  };

  /**
   *TODO:サイズ変更を境界で行う??
   * @memberof PublicMap
   */
  changeZoom = (e) => {
    this.setState({ nowZoom: e });
  };

  /**
   * 地図の中心座標の取得
   *
   * @memberof PublicMap
   */
  onMoveEnd = (e) => {
    const { lat, lng } = e;
    const tmpLat = lat.toFixed(5);
    const tmpLng = lng.toFixed(5);

    this.setState({ latlng: [tmpLat, tmpLng] });
    this.setUrl({ point: [tmpLat, tmpLng] });
  };

  /**
   * 地図クリック時に検索の中心地を変更する。
   * @memberof PublicMap
   */
  onMapClick = (e) => {
    const { lat, lng } = e;
    this.setState({
      currentPoint: [lng, lat],
      currentMarker: <Marker position={[lat, lng]} icon={markerIcon} />,
    });
  };

  /**
   * 現在地の取得を行う。
   *
   * @memberof PublicMap
   */
  getCurrentCod = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // 位置情報の取得に成功した場合の処理
          const { coords = '' } = position;
          const { latitude: lat = '', longitude: lng = '' } = coords;
          const { nowZoom } = this.state;

          const marker = <Marker position={[lat, lng]} icon={markerIcon} />;

          this.setState({
            mapPositon: [lat, lng],
            currentPoint: [lng, lat],
            mapZoom: nowZoom,
            currentMarker: marker,
            mapKey: commons.randomNum(),
          });
        },
        () => {
          // 位置情報の取得に失敗した場合の処理
          window.alert('現在地の取得に失敗しました。');
        }
      );
    } else {
      window.alert('このブラウザでは地理位置情報がサポートされていません。');
    }
  };

  /**
   * 凡例の要素を作成する。
   *
   * @memberof PublicMap
   */
  createUseGuide = () => {
    const { guideList } = this.state;
    const returnGuide = [];
    const duplicateCheck = [];
    for (let i = 0; i < guideList.length; i += 1) {
      const [key, value] = guideList[i].split('_');
      const tmpValue = parseInt(value, 10);

      // ハザードの凡例
      if (key === 'hzrdFlag') {
        // 同一凡例を省くための処理
        let insKey = guideList[i];
        if (tmpValue === 2) insKey = `${key}_1`;
        if (tmpValue === 16) insKey = `${key}_8`;
        if (tmpValue === 64) insKey = `${key}_32`;
        if (tmpValue === 128) insKey = `${key}_32`;

        if (duplicateCheck.indexOf(insKey) === -1) duplicateCheck.push(insKey);
        else continue;

        returnGuide.push(commons.useGuide(tmpValue));
      } else if (key === 'fcmlyFlag') {
        const tmpRes = this.fcmlyUseGuide(tmpValue);
        if (tmpRes !== false) returnGuide.push(tmpRes);
      }
    }

    return returnGuide;
  };

  /**
   * URLに情報を設定する。
   * @memberof PublicMap
   */
  setUrl = ({
    point = '',
    zoom = '',
    fcmlyFlag = '',
    hzrdFlag = '',
    mapFlag = '',
    isGuideOpen = '',
  }) => {
    const { history } = this.props;
    const {
      latlng,
      nowZoom,
      fcmlyFlag: fcmly,
      hzrdFlag: hzrd,
      mapFlag: map,
      isGuideOpen: guide,
    } = this.state;

    // 引数がない場合は、stateのものを使用する。
    const tmpP = point === '' ? latlng : point;
    const [lat, lng] = tmpP;
    const tmpZ = zoom === '' ? nowZoom : zoom;
    const tmpFcmly = fcmlyFlag === '' ? fcmly : fcmlyFlag;
    const tmpHazrd = hzrdFlag === '' ? hzrd : hzrdFlag;
    const tmpMap = mapFlag === '' ? map : mapFlag;
    const tmpGuide = isGuideOpen === '' ? guide : isGuideOpen;
    const useGuide = tmpGuide ? '1' : '0';

    const urlSearch = `lat=${lat}&lng=${lng}&zoom=${tmpZ}&fcmly=${tmpFcmly}&hzrd=${tmpHazrd}&map=${tmpMap}&guide=${useGuide}`;

    history.push({ search: urlSearch });
    this.setState({ urlSearch });
  };

  /**
   * 画面遷移
   * @memberof PublicMap
   */
  onClickBtnMove = (path) => {
    const { history } = this.props;
    const { urlSearch = '' } = this.state;
    history.push({ pathname: path, search: urlSearch });
  };

  /**
   * メニューにチェックを入れた際の処理
   * @memberof PublicMap
   */
  fcmlyUseGuide = (value) => {
    const { havenGuide, postGuide, roadGuide, stdGuide, areaGuide } = this.state;
    if (value === 1) return havenGuide;
    if (value === 2) return postGuide;
    if (value === 4) return roadGuide;
    if (value === 16) return stdGuide;
    if (value === 32) return areaGuide;
    return false;
  };

  /**
   * メニューにチェックを入れた際の処理
   * @memberof PublicMap
   */
  changeMenu = (objKey, setValue, tmpKey) => {
    const { guideList } = this.state;
    const num = guideList.indexOf(tmpKey);
    if (num === -1) guideList.push(tmpKey);
    else guideList.splice(num, 1);

    this.setState({ [objKey]: setValue, guideList });
    this.setUrl({ [objKey]: setValue });
  };

  /**
   * 共通のメニューチェック要素
   * @memberof PublicMap
   */
  menuList = (objKey, tmpValue, dispName, kind, dataDisp) => {
    const { [objKey]: objValue } = this.state;
    if (dataDisp === 0) return [];

    let checked = false;
    let setValue = false;
    if (kind === '0') {
      checked = objValue & tmpValue;
      setValue = objValue & tmpValue ? objValue - tmpValue : objValue + tmpValue;
    } else if (kind === '1') {
      checked = objValue === tmpValue;
      setValue = tmpValue;
    }

    const tmpKey = `${objKey}_${tmpValue}`;

    return (
      <li>
        <span>
          <label className="form-check-label" htmlFor={tmpKey}>
            <input
              className="form-check-input mr10"
              type={kind === '0' ? 'checkbox' : 'radio'}
              id={tmpKey}
              onClick={() => this.changeMenu(objKey, setValue, tmpKey)}
              checked={checked}
              readOnly
            />
            {dispName}
          </label>
        </span>
      </li>
    );
  };

  /**
   * 距離による検索を実行
   * @memberof PublicMap
   */
  searchDistance = async () => {
    const { currentPoint, facility, googleMapPath, jpMasta, lgCd, prmsn } = this.state;
    const tmpSetting = { facility, googleMapPath };
    const resData = await this.getData(tmpSetting, jpMasta, lgCd, prmsn, currentPoint);
    this.setState({ ...resData });
  };

  /**
   * 距離による検索用の要素作成
   * @memberof PublicMap
   */
  distanceArea = () => {
    const { dispDistance } = this.state;

    const changeBtn = (kind) => (
      <button
        type="button"
        onClick={() => this.setState({ dispDistance: dispDistance + kind })}
        className="distanceBtn"
        disabled={(dispDistance === 0 && kind === -1) || (dispDistance === 100 && kind === 1)}
      >
        {kind === 1 ? '+' : '-'}
      </button>
    );

    return (
      <div className="distance-area">
        現在地からの検索距離(半径)
        <div className="">
          {changeBtn(-1)}
          <input
            type="range"
            min="0"
            max="100"
            value={dispDistance}
            onChange={(e) => this.setState({ dispDistance: parseInt(e.target.value, 10) })}
          />
          {changeBtn(1)}
        </div>
        <div className="">
          現在の値：{dispDistance} [km]
          <button type="button" onClick={this.searchDistance} className="distanceSrhBtn">
            検索
          </button>
        </div>
      </div>
    );
  };

  /**
   * テスト用
   * @memberof PublicMap
   */
  test = () => {
    console.log('test');
  };

  render() {
    const {
      agree,
      agreeFlag,
      lgCrypt,
      // 地図系統
      formTitle,
      iconUrl,
      mapFlag,
      mapPositon,
      mapZoom,
      mapKey,
      tileAttribution,
      tileUrl,
      tileElevUrl,
      tileHillshade,
      tileFlyUrl,
      // マーカーのデータ
      resSumData = 1, // 防災・くらしの情報に表示しているマーカー数
      resDistanceData = 1, // 範囲検索に対応している情報のマーカー数
      // マーカー系統
      postMarker,
      roadMarker,
      havenMarker,
      radioMarker,
      stdMarker,
      areaMarker,
      // メニュー系統
      ocStat,
      isGuideOpen,
      fcmlyFlag = 0,
      facility = '',
      hzrdFlag = 0,
      hazard = '',
      hazardList,
      dispFcmlyFlag = 0,
      // その他
      linkContent,
      currentMarker,
      imgModal,
      currentPoint,
      dispDistance,
    } = this.state;
    const dispGuide = this.createUseGuide();

    return (
      <div id="container" className="menu_l" style={{ overflow: 'hidden' }}>
        {imgModal}
        {agreeFlag ? (
          <main>
            <div id="contentMap">
              {/* 以下は絶対配置 */}
              {/* 設定座標へ戻るボタン用 */}
              <div
                className="infoBtnArea"
                style={{ bottom: isGuideOpen && dispGuide.length > 0 ? '250px' : '30px' }}
              >
                <button
                  type="button"
                  className={`btnInitPosi btnGuide mb10 ${isGuideOpen ? 'btnGuideOn' : ''}`}
                  onClick={() => {
                    this.setState({ isGuideOpen: !isGuideOpen });
                    this.setUrl({ isGuideOpen: !isGuideOpen });
                  }}
                  title="凡例を表示"
                >
                  {''}
                </button>
                <button
                  type="button"
                  className="btnInitPosi"
                  onClick={() => this.getCurrentCod()}
                  title="現在地を表示"
                >
                  {''}
                </button>
              </div>
              {/* 凡例の表示 */}
              {dispGuide.length === 0 ? null : (
                <div
                  id="legend-area"
                  className={ocStat ? 'open' : 'closed'}
                  style={{ height: isGuideOpen ? '' : '0px' }}
                >
                  <div id="legend-scroll">{dispGuide}</div>
                </div>
              )}
              <article>
                <section>
                  {mapPositon.length === 0 ? (
                    <img src={imgLoading} alt="" className="loadingImg" />
                  ) : (
                    <MapContainer
                      id="map"
                      center={mapPositon}
                      zoom={mapZoom}
                      zoomControl={false} // ズームコントローラーを非表示にできる。
                      boxZoom={false}
                      maxBounds={[
                        [15, 110], // 南西（沖縄の下）
                        [50, 154], // 北東（北海道の上）
                      ]}
                      maxBoundsViscosity={0.5} // 1.0で完全に範囲外にスクロールできなくする
                      key={mapKey}
                      className="map-test"
                    >
                      <ZoomControl
                        position={window.innerWidth <= 769 ? 'bottomleft' : 'topright'}
                        zoomInTitle="拡大"
                        zoomOutTitle="縮小"
                      />
                      <MyComponent
                        // changeZoom=""
                        changeZoom={this.changeZoom}
                        onMoveEnd={this.onMoveEnd}
                        onMapClick={this.onMapClick}
                      />
                      {/* 地図系統 */}
                      {mapFlag === '0' ? (
                        <TileLayer attribution={tileAttribution} url={tileUrl} />
                      ) : null}
                      {/* 標高図 */}
                      {mapFlag === '20' ? (
                        <TileLayer url={tileElevUrl} maxNativeZoom={15} minNativeZoom={5} />
                      ) : null}
                      {/* 陰影起伏図 */}
                      {mapFlag === '25' ? (
                        <TileLayer url={tileHillshade} maxNativeZoom={16} minNativeZoom={5} />
                      ) : null}
                      {/* 航空写真 */}
                      {mapFlag === '30' ? <TileLayer url={tileFlyUrl} /> : null}
                      {/* ハザードマップ */}
                      <span key={`${mapFlag}_hazard`}>
                        {hzrdFlag & 1 ? hazardList[0] : null}
                        {hzrdFlag & 2 ? hazardList[1] : null}
                        {hzrdFlag & 4 ? hazardList[2] : null}
                        {hzrdFlag & 8 ? hazardList[3] : null}
                        {hzrdFlag & 16 ? hazardList[4] : null}
                        {hzrdFlag & 32 ? hazardList[5] : null}
                        {hzrdFlag & 64 ? hazardList[6] : null}
                        {hzrdFlag & 128 ? hazardList[7] : null}
                        {hzrdFlag & 256 ? hazardList[8] : null}
                      </span>
                      {/* 以下はマーカー系統 */}
                      {fcmlyFlag & 1 ? havenMarker : null}
                      {fcmlyFlag & 2 ? postMarker : null}
                      {fcmlyFlag & 4 ? roadMarker : null}
                      {fcmlyFlag & 8 ? radioMarker : null}
                      {fcmlyFlag & 16 ? stdMarker : null}
                      {fcmlyFlag & 32 ? areaMarker : null}
                      {currentMarker}
                      {/* 検索範囲 */}
                      {dispDistance}
                      {dispDistance > 0 ? (
                        <Circle
                          center={[currentPoint[1], currentPoint[0]]}
                          radius={dispDistance * 1000}
                          pathOptions={{ opacity: 0.5 }}
                        />
                      ) : null}
                    </MapContainer>
                  )}
                </section>
              </article>
              {/* ZoomControlにスタイルをかぶせる */}
              <style key={`${isGuideOpen}_style`}>{`.leaflet-bottom.leaflet-left {bottom: ${
                isGuideOpen ? 237 : 20
              }px;}`}</style>
            </div>
            <div id="menu">
              <input
                id="openNav"
                name="btnDrawer"
                type="checkbox"
                checked={ocStat}
                readOnly
                onClick={() => this.setState({ ocStat: !ocStat })}
              />
              <label id="btnDrawer" className="btntoggle" htmlFor="openNav">
                <span />
                <span />
                <span />
                {''}
              </label>
              <div id="drawer">
                <div id="siteTitle">
                  {iconUrl === '' ? null : <img className="site-icon" src={iconUrl} alt="" />}
                  {formTitle === 'none' ? '' : formTitle}
                </div>
                <nav>
                  <ul className="sideMenu">
                    {hazard === 0 ? null : (
                      <li className="settings">
                        <input id="accordionMenu10" className="accordion" type="checkbox" />
                        <label className="menuTitle accordion-label" htmlFor="accordionMenu10">
                          {'ハザードマップ'}
                        </label>
                        <div className="accordion-item">
                          <ul>
                            {this.menuList('hzrdFlag', 1, '洪水による浸水 (最大)', '0', hazard & 1)}
                            {this.menuList('hzrdFlag', 2, '洪水による浸水 (計画)', '0', hazard & 2)}
                            {this.menuList('hzrdFlag', 4, '浸水継続時間 (最大)', '0', hazard & 4)}
                            {this.menuList('hzrdFlag', 8, '倒壊リスク (氾濫流)', '0', hazard & 8)}
                            {this.menuList('hzrdFlag', 16, '倒壊リスク (河岸)', '0', hazard & 16)}
                            {this.menuList('hzrdFlag', 64, '急傾斜地の崩壊', '0', hazard & 64)}
                            {this.menuList('hzrdFlag', 32, '土石流', '0', hazard & 32)}
                            {this.menuList('hzrdFlag', 128, '地すべり', '0', hazard & 128)}
                            {this.menuList('hzrdFlag', 256, '津波による浸水', '0', hazard & 256)}
                          </ul>
                        </div>
                      </li>
                    )}
                    {facility === 0 || resSumData === 0 ? null : (
                      <li className="settings">
                        <input id="accordionMenu20" className="accordion" type="checkbox" />
                        <label className="menuTitle accordion-label" htmlFor="accordionMenu20">
                          {'防災・くらしの情報'}
                        </label>
                        <div className="accordion-item">
                          <ul>
                            {this.menuList('fcmlyFlag', 1, '避難所', '0', dispFcmlyFlag & 1)}
                            {this.menuList('fcmlyFlag', 2, '投稿データ', '0', dispFcmlyFlag & 2)}
                            {this.menuList('fcmlyFlag', 4, '道路規制', '0', dispFcmlyFlag & 4)}
                            {this.menuList('fcmlyFlag', 8, '屋外子局', '0', dispFcmlyFlag & 8)}
                            {this.menuList('fcmlyFlag', 16, '位置情報', '0', dispFcmlyFlag & 16)}
                            {this.menuList('fcmlyFlag', 32, 'エリア情報', '0', dispFcmlyFlag & 32)}
                            {resDistanceData > 0 ? this.distanceArea() : null}
                          </ul>
                        </div>
                      </li>
                    )}
                    <li className="settings">
                      <input id="accordionMenu30" className="accordion" type="checkbox" />
                      <label className="menuTitle accordion-label" htmlFor="accordionMenu30">
                        {'地図の種類を変える'}
                      </label>
                      <div className="accordion-item">
                        <ul>
                          <li style={{ color: '#ffffff', marginBottom: '5px' }}>
                            国土地理院マップ
                            {/* <span>国土地理院マップ</span> */}
                          </li>
                          {this.menuList('mapFlag', '0', '淡色地図', '1', true)}
                          {this.menuList('mapFlag', '20', '色別標高図', '1', true)}
                          {this.menuList('mapFlag', '25', '陰影起伏図', '1', true)}
                          {this.menuList('mapFlag', '30', '空中写真', '1', true)}
                        </ul>
                      </div>
                    </li>
                    {linkContent}
                  </ul>
                </nav>
                <div className="mt20 mb10 ml10">
                  <button
                    type="button"
                    className="showList"
                    onClick={() => this.onClickBtnMove(`../list/${lgCrypt}`)}
                  >
                    一覧表示に切替える
                  </button>
                  <button
                    type="button"
                    className="closeNav"
                    onClick={() => this.setState({ ocStat: !ocStat })}
                  >
                    メニューを閉じる
                  </button>
                </div>
              </div>
            </div>
          </main>
        ) : (
          commonHtml.agreeModal(agree, this.agreeInit)
        )}
      </div>
    );
  }
}

PublicMap.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(PublicMap);
